(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-mega-menu"] && !Shopify.designMode) return;
  try {
    const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const desktopMq = window.matchMedia('(min-width: 1170px)');

  const updateHeaderBottom = () => {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    root.style.setProperty('--mp-header-bottom', `${Math.max(0, rect.bottom)}px`);
    root.style.setProperty('--header-height', `${Math.max(0, rect.height)}px`);
  };

  let raf = 0;
  const schedule = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      raf = 0;
      updateHeaderBottom();
    });
  };

  updateHeaderBottom();
  window.addEventListener('resize', schedule, { passive: true });
  // Intentionally not updating on scroll: the panel should stay pinned.

  // An open panel is moved out to <body>, so every panel has to remember which
  // <details> it came from. Looking the panel up by selector instead lets a fast
  // hover across the top-level items put one category's panel back into another
  // category's slot, and the menu then shows the wrong category until a reload.
  const panelOf = new WeakMap();
  const detailsOf = new WeakMap();
  const placeholderOf = new WeakMap();

  const getPanel = (details) => {
    if (!details) return null;
    let panel = panelOf.get(details);
    if (!panel) {
      panel = details.querySelector('.mp-mega__panel');
      if (panel) {
        panelOf.set(details, panel);
        detailsOf.set(panel, details);
      }
    }
    return panel;
  };

  const portalPanelToBody = (details) => {
    const panel = getPanel(details);
    if (!panel) return;
    if (panel.dataset.mpPortaled === '1') return;
    const placeholder = document.createElement('span');
    placeholder.dataset.mpMegaPanelPlaceholder = '1';
    panel.before(placeholder);
    placeholderOf.set(details, placeholder);
    document.body.appendChild(panel);
    panel.dataset.mpPortaled = '1';
  };

  const restorePanelFromBody = (details) => {
    const panel = getPanel(details);
    if (!panel) return;
    if (panel.dataset.mpPortaled !== '1') return;
    const placeholder = placeholderOf.get(details);
    if (placeholder && placeholder.isConnected) {
      placeholder.before(panel);
      placeholder.remove();
    } else {
      details.appendChild(panel);
    }
    placeholderOf.delete(details);
    panel.dataset.mpPortaled = '0';
  };

  const closeDetails = (details) => {
    if (!details) return;
    details.open = false;
    restorePanelFromBody(details);
  };

  // `toggle` fires asynchronously and a quick open/close pair can be coalesced
  // into a single event, so panels are put back synchronously here as well.
  const closeOthers = (current) => {
    document.querySelectorAll('.mp-mega__details[open]').forEach((other) => {
      if (other !== current) closeDetails(other);
    });
    document.querySelectorAll('.mp-mega__panel[data-mp-portaled="1"]').forEach((panel) => {
      const owner = detailsOf.get(panel);
      if (owner && owner !== current) restorePanelFromBody(owner);
    });
  };

  let closeTimer = 0;
  const cancelClose = () => {
    if (!closeTimer) return;
    window.clearTimeout(closeTimer);
    closeTimer = 0;
  };

  const openDetails = (details) => {
    if (!desktopMq.matches) return;
    cancelClose();
    if (details.open) {
      closeOthers(details);
      return;
    }

    // Close header predictive search when user moves to the menu.
    const headerPredictive = document.querySelector('.section-header predictive-search[open], .section-header predictive-search[loading]');
    if (headerPredictive && typeof headerPredictive.close === 'function') headerPredictive.close(false);
    const headerSearchInput = document.querySelector('.section-header #Search-In-Header-Desktop');
    headerSearchInput?.blur?.();

    details.open = true;
    portalPanelToBody(details);
    closeOthers(details);
    schedule();
  };

  const scheduleClose = (details) => {
    if (!desktopMq.matches) return;
    cancelClose();
    closeTimer = window.setTimeout(() => {
      closeTimer = 0;
      // Don't close if pointer moved into this item's portaled panel.
      const panel = panelOf.get(details);
      if (panel && panel.matches(':hover')) return;
      closeDetails(details);
    }, 80);
  };

  // Desktop: open mega menus on hover/focus (not click).
  const bindHoverOpen = () => {
    document.querySelectorAll('.mp-mega__details').forEach((details) => {
      if (details.dataset.mpHoverBound === '1') return;
      details.dataset.mpHoverBound = '1';
      getPanel(details);

      details.addEventListener('mouseenter', () => openDetails(details));
      details.addEventListener('focusin', () => openDetails(details));
      details.addEventListener('mouseleave', (event) => {
        const panel = panelOf.get(details);
        // If leaving details into the panel, keep it open.
        if (panel && event.relatedTarget && panel.contains(event.relatedTarget)) return;
        scheduleClose(details);
      });
    });
  };

  bindHoverOpen();

  // Keep open while hovering the panel; close when leaving it (unless moving back
  // into the item it belongs to). Bound once for all panels, not once per item.
  document.addEventListener(
    'mouseenter',
    (event) => {
      const panel = event.target;
      if (!(panel instanceof HTMLElement)) return;
      if (!panel.classList.contains('mp-mega__panel')) return;
      cancelClose();
    },
    true
  );
  document.addEventListener(
    'mouseleave',
    (event) => {
      const panel = event.target;
      if (!(panel instanceof HTMLElement)) return;
      if (!panel.classList.contains('mp-mega__panel')) return;
      const owner = detailsOf.get(panel);
      if (!owner) return;
      if (event.relatedTarget && owner.contains(event.relatedTarget)) return;
      scheduleClose(owner);
    },
    true
  );

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.classList.contains('mp-mega__details')) return;
    if (details.open) {
      if (desktopMq.matches) portalPanelToBody(details);
      schedule();
      closeOthers(details);
    } else {
      restorePanelFromBody(details);
    }
  });

  const closeOpenMega = () => {
    cancelClose();
    closeOthers(null);
  };

  // Leaving the desktop breakpoint would otherwise strand an open panel in <body>,
  // where the mobile rules that hide .mp-mega no longer reach it.
  desktopMq.addEventListener('change', () => {
    if (!desktopMq.matches) closeOpenMega();
  });

  document.querySelector('[data-mp-mega-backdrop]')?.addEventListener('click', () => {
    if (!desktopMq.matches) return;
    closeOpenMega();
  });

  document.addEventListener('click', (event) => {
    const open = document.querySelector('.mp-mega__details[open]');
    if (!open) return;
    if (open.contains(event.target)) return;
    const panel = panelOf.get(open);
    if (panel?.contains(event.target)) return;
    closeOpenMega();
  }, { capture: true });
  } catch(e) { console.error(e); }
})();

})();
